export default class ZTableColumn {
  label
  prop
  width
  align
  fixed
  columns

  parentColumn
  deep
  rDeep = 1
  leafColumns = []

  constructor ({label, prop, width, align, fixed, columns}, parentColumn, deep = 1) {
    this.label = label
    this.prop = prop
    this.width = width
    this.align = align || 'left'
    this.fixed = fixed || false
    this.deep = deep - 1

    if (parentColumn) {
      this.parentColumn = parentColumn
    }

    if (Array.isArray(columns) && columns.length > 0) {
      deep++
      this.columns = columns.map(column => new ZTableColumn(column, this, deep))
    } else {
      if (parentColumn) {
        this.setParentLeafColumns(this, deep)
      } else {
        this.leafColumns.push(this)
      }
    }
  }

  setParentLeafColumns (childColumn, deep) {
    let {parentColumn} = this
    this.leafColumns.push(childColumn)

    let rDeep = deep - this.deep

    if (rDeep > this.rDeep) {
      this.rDeep = rDeep
    }

    if (parentColumn) {
      parentColumn.setParentLeafColumns(childColumn, deep)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ZTable/ZTableColumn.js